import OnlyHtmlArticleSection from './OnlyHtmlArticleSection';

export default OnlyHtmlArticleSection;
